import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { handleTrack } from '../../../../../utils/tracker';
import { DEFAULT_ACTIVE_VERTICAL_TAB } from '../../constants';
import { PRODUCT_GUIDE_STEPS } from '../../data/product-guide.data';
import { LeftTabSection } from './LeftTabSection';
import { PrevNextButtonSection } from './PrevNextButtonSection';

export const VerticalTab = () => {
  const router = useRouter();
  const [activeTab, setActiveTab] = useState<string>(
    DEFAULT_ACTIVE_VERTICAL_TAB
  );

  useEffect(() => {
    const { tab } = router.query;
    if (tab) setActiveTab(tab as string);
  }, [router.query]);

  const handleOnTabChange = (tabId: string, type = 'click') => {
    const pathName = window.location.pathname || '/s/cleartax-itr-filing-guide';
    const newUrl = {
      pathname: pathName,
      query: { ...router.query, tab: tabId },
    };

    router.replace(newUrl, undefined, { shallow: true, scroll: false });
    setActiveTab(tabId);

    const trackLabel =
      type === 'click' ? `guide_${tabId}` : `guide_${type}_tab`;
    handleTrack({ label: trackLabel });
  };

  const getNextTab = () => {
    const currentIndex = PRODUCT_GUIDE_STEPS.findIndex(
      (item) => item.id === activeTab
    );
    if (currentIndex < PRODUCT_GUIDE_STEPS.length - 1) {
      return PRODUCT_GUIDE_STEPS[currentIndex + 1]?.id;
    }
    return null; // or return the first tab to cycle through
  };

  const getPreviousTab = () => {
    const currentIndex = PRODUCT_GUIDE_STEPS.findIndex(
      (item) => item.id === activeTab
    );
    if (currentIndex > 0) {
      return PRODUCT_GUIDE_STEPS[currentIndex - 1]?.id;
    }
    return null; // or return the last tab to cycle through
  };

  const handleNext = () => {
    const nextTab = getNextTab();
    if (nextTab) {
      handleOnTabChange(nextTab, 'next');
    }
  };

  const handlePrevious = () => {
    const previousTab = getPreviousTab();
    if (previousTab) {
      handleOnTabChange(previousTab, 'prev');
    }
  };

  const content = PRODUCT_GUIDE_STEPS.find(
    (item) => item.id === activeTab
  )?.content(handleNext);

  return (
    <div
      className="flex items-start w-full my-2 sm:flex-col sm:my-0 relative"
      data-testid="vertical-tab-section"
    >
      <div className="w-1/4 sm:w-full h-[calc(100vh-64px)] overflow-y-auto sm:h-auto">
        <LeftTabSection
          activeTab={activeTab}
          handleOnTabChange={handleOnTabChange}
        />
      </div>
      <div className="w-3/4 sm:w-full">
        <div className="sm:h-auto">
          <div className="h-[calc(100vh-138px)] overflow-y-auto sm:h-auto">
            {content}
          </div>
          <PrevNextButtonSection
            handleNext={handleNext}
            handlePrevious={handlePrevious}
            getNextTab={getNextTab}
            getPreviousTab={getPreviousTab}
          />
        </div>
      </div>
    </div>
  );
};
